import React, { useCallback, useMemo } from 'react';

import styles from './RubricQuestionPickerModal.module.scss';

function AssessmentCard({ group, onChooseAssessment }) {
  const handleClick = useCallback(() => {
    onChooseAssessment(group.key);
  }, [group.key, onChooseAssessment]);

  const longDateFormat = new Intl.DateTimeFormat(undefined, {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });

  const stats = useMemo(() => {
    const questionSetCount = group.questionSets.length;
    const questionCount = group.questionSets.reduce(
      (acc, questionSet) => acc + questionSet.questions.length,
      0
    );
    return {
      questionSetCount,
      questionCount,
      lastRunAt: group.lastRunAt ? new Date(group.lastRunAt) : null,
      runCount: group.runCount,
      exponentialDecayScore: group.exponentialDecayScore,
      sourceRecency: group.sourceRecency,
    };
  }, [group]);

  return (
    <button
      type="button"
      className={styles['assessment-card']}
      onClick={handleClick}
    >
      <div className={styles['assessment-card-label']}>
        <label>{group.key}</label>
      </div>
      <div className={styles['assessment-card-label']}>
        <label>Uses</label>
      </div>
      <div className={styles['assessment-card-label']}>
        <label>Last used</label>
      </div>
      <div className={styles['assessment-name']}>{group.primaryName}</div>
      <div className={styles['assessment-run-count']}>
        {stats.runCount}
        {/* {`Used ${stats.runCount} ${pluralize(stats.runCount, 'time', 'times')}`} */}
      </div>
      <div className={styles['assessment-last-run-at']}>
        {stats.lastRunAt ? longDateFormat.format(stats.lastRunAt) : 'Never'}
      </div>
      <div className={styles['assessment-question-count']}>
        {stats.questionSetCount} question sets, {stats.questionCount} questions
      </div>
    </button>
  );
}

export default AssessmentCard;
